import {inject, Injectable} from "@angular/core";
import {EnvironmentService, EnvironmentType, EnvironmentTypeShortNames} from "./environment.service";
import {BASE_PATH} from "../apis/backend";

@Injectable()
export class TitleService {
    
    private BaseTitle = "Northern Row Hub";
    private _basePath: string;
    private _initialized = false;
    
    constructor(private _environmentService: EnvironmentService) {
        this._basePath = inject(BASE_PATH);
    }
    
    public InitTitle() {
        if (!this._initialized) {
            this.SetTitle('');
        }
    }
    
    public SetTitle(subtitle: string) {
        let title = this.BaseTitle;
        let environmentType = this._environmentService.GetEnvironmentType();
        if (environmentType != EnvironmentType.Unknown && environmentType != EnvironmentType.Prod) {
            title += ' [' + EnvironmentTypeShortNames[environmentType] + ']';
        }
        if (subtitle) {
            title += ' - ' + subtitle;
        }
        document.title = title;
        
        if (!this._initialized) {
            document.getElementById('appFavicon')
                .setAttribute(
                    'href',
                    `${this._basePath}/assets/favicon-${this.faviconSuffix(environmentType)}.ico`);
        }
        this._initialized = true;
    }
    
    private faviconSuffix(environmentType: EnvironmentType): string {
        switch (environmentType) {
            case EnvironmentType.Prod:
                return 'prod';
            case EnvironmentType.Beta:
                return 'beta';
            case EnvironmentType.Dev:
                return 'dev';
            default:
                return 'unknown';
        }
    }
}